// @ts-nocheck: converted from JS

import ManageTeam from '@/components/Team';

export default ManageTeam;
